export const getCurrentOrgSlug = () => {
  const slug = window.location.pathname.split('/').filter(Boolean)[0];
  return slug;
};
